<template lang="pug">
    #pessoa-operacao
        card
            el-form.form(label-position="top" size="small")
                .pessoa
                    el-form-item.w-66
                        template(slot="label")
                            span.campo_obrigatorio {{ $t('mensagens.comuns.produtor') }}
                        el-select.w-100(
                            v-model="idPessoaSelecionada"
                            :placeholder="$t('mensagens.territorio.vincularPessoa.buscaInteligentePorRuc')"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="remoteMethod")
                            el-option(
                                v-for="pessoa in listaPessoas"
                                :key="'pessoa' + pessoa.id"
                                :label="pessoa.nomeRazaoSocial + ' - ' + numeralStringFormatTocpfCnpj(pessoa.cpfCnpj)"
                                :value="pessoa.id")
                            div.custom-padding-pessoa-desejada
                                span {{ $t('mensagens.territorio.vincularPessoa.naoEncontrouAPessoaDesejada') }}
                            div.custom-padding-cadastrar-pessoa
                                el-button.pessoa__btn-cadastro(
                                    type="primary"
                                    @click='cadastrarPessoa'
                                    size='mini')
                                    | {{ $t('mensagens.operacao.formularioPessoa.cadastrarProdutor') }}
                    el-form-item.w-33
                        template(slot="label")
                            span.campo_obrigatorio {{ $t('mensagens.operacao.formularioPessoa.papel') }}
                        el-select.w-100(
                            v-model="idPapelSelecionado"
                            :placeholder="$t('mensagens.operacao.acoes.selecione')")
                            el-option(
                                v-for='papel in listaPapeisFiltrados'
                                :key="'papel' + papel.id"
                                :label="papel.nome"
                                :value="papel.id")
                    el-form-item
                        .botao-adicionar
                            span {{ $t('mensagens.operacao.acoes.adicionar') }}
                            i.el-icon-circle-plus-outline.icon-plus-vincular-pessoa(
                                :popup="$t('mensagens.comuns.adicionar')",
                                @click='addPessoa()'
                            )
    
            span.titulo(v-if="pessoasOperacoes.length > 0") {{ $t('mensagens.operacao.formularioPessoa.pessoasAdicionadas') }}
            <br v-if="pessoasOperacoes.length > 0" />
            el-row.tabela(v-if="pessoasOperacoes.length > 0" :gutter='24')
                el-col.mb-2(:span='7')
                    span.tituloColuna {{ $t('mensagens.operacao.tabela.nomeRazaoSocial') }}
                el-col.mb-2(:span='8')
                    span.tituloColuna {{ $t('mensagens.operacao.tabela.documento') }}
                el-col.mb-2(:span='8')
                    span.tituloColuna {{ $t('mensagens.operacao.formularioPessoa.papel') }}
                el-col.mb-2(:span='1')
                    span.tituloColuna {{ $t('mensagens.operacao.acoes.remover') }}
                el-col(v-if="pessoasOperacoes.length > 0" :span='24', class="grid-info-pessoas")
                    div.w-100(v-for='(pessoaOp, index) in pessoasOperacoes')
                        el-form(:model='pessoaOp' :ref="'formPessoa' + index")
                            el-col(:span='7')
                                span {{ pessoaOp.pessoa.nomeRazaoSocial }}
                            el-col(:span='8')
                                span {{ numeralStringFormatTocpfCnpj(pessoaOp.pessoa.cpfCnpj) }}
                            el-col(:span='8')
                                el-form-item.margin(prop='papel')
                                    el-select(
                                        v-model="pessoaOp.papel"
                                        :placeholder="$t('mensagens.operacao.acoes.selecione')"
                                        class="w-100"
                                        @change="atualizarListaPessoas"
                                        value-key="id")
                                        el-option(
                                            v-for='papel in listaPapeisFiltrados'
                                            :key='papel.id'
                                            :label="papel.nome"
                                            :value="papel")
                            el-col(:span='1')
                                i.el-icon-delete.icon-remover(@click='openModalRemover(pessoaOp)')
            el-col(v-if="pessoasOperacoes.length === 0" :span='24', class="sem-vinculo-box")
                hr.custom-hr
                div.w-100
                span.sem-registro {{ $t('mensagens.operacao.formularioPessoa.nenhumProdutorAdicionado') }}
    
            #modal-delete-pessoa.row(v-if='deletePessoaModal')
                el-dialog(:visible.sync='deletePessoaModal', width='500px')
                    span(slot="title")
                        h1.mb-2.font-weight-bold.remover-pessoa-title {{ $t('mensagens.operacao.formularioPessoa.removerPessoa') }}
                    .column.d-flex.justify-content-center.align-items-center.flex-column
                        h2.mb16() {{ $t('mensagens.operacao.formularioPessoa.confirmaRemoverRegistro') }}
                        .buttons.mb16()
                            el-button(size="mini", @click='closeModalRemover')
                                | {{ $t('mensagens.operacao.acoes.cancelar') }}
                            el-button(type="primary", size="mini", @click='deletePessoa')
                                | {{ $t('mensagens.operacao.acoes.remover') }}

            ModalEditarCadastrarRepresentanteParaguai(
                :mostrar='mostrarModalEditarCadastrarRepresentante',
                :dadosRepresentante='pessoa',
                :isVincularPessoaParaguai='true'
                @atualizarListaRepresentantes='buscarPessoas',
                @fechar='fecharModalEditarCadastrarRepresentante'
            )
    
    </template>
    
    <script>
    import Card from '../Card.vue';
    import formatters from '@/utils/formatters';
    import validators from '@/utils/validators';
    import RepresentanteService from '@/services/RepresentanteService';
    import PapelPessoaService from '@/services/PapelPessoaService';
    import ModalResultadoDiagnosticoPessoa from '@/components/operacao/gestao/ModalResultadoDiagnosticoPessoaOperacao.vue';
    import ModalEditarCadastrarRepresentanteParaguai from '@/components/ModalEditarCadastrarRepresentanteParaguai.vue';
    
    export default {
        name: 'VincularPessoa',
    
        emits: ['dadosPessoa'],
    
        props: {
            representantesSelecionados: {
                type: Array,
                default: () => []
            }
        },
    
        components: {
            Card,
            ModalResultadoDiagnosticoPessoa,
            ModalEditarCadastrarRepresentanteParaguai
        },
    
        data() {
            return {
                idPessoaSelecionada: null,
                idPapelSelecionado: null,
                listaPessoas: [],
                listaPapeis: [],
                paginacao: {
                    paginaAtual: 1,
                    tamanhoPagina: 5
                },
                pessoasOperacoes: [],
                pessoaOperacaoSelecionada: null,
                deletePessoaModal: false,
                mostrarModalDiagnosticoPessoa: false,
                mostrarModalEditarCadastrarRepresentante: false,
                pessoa: {}
            };
        },
    
        async mounted() {
            await this.buscarPessoas();
            await this.buscarPapeis();
        },

        computed: {
            listaPapeisFiltrados() {
                return this.listaPapeis.filter(papel =>
                    papel.nome?.toLowerCase() === 'propietario' ||
                    papel.nome?.toLowerCase() === 'arrendatario'
                );
            }
        },

        watch: {
            representantesSelecionados: {
                handler(newValue) {
                    this.verificarEdicao(newValue);
                },
                deep: true
            }
        },
    
        methods: {
            numeralStringFormatTocpfCnpj(cpfCnpj) {
                return formatters.numeralStringFormatToDocumento(cpfCnpj);
            },

            isDocumentoBusca(input) {
                const documento = formatters.removerPontuacaoDocumento(input || '');
                return validators.validarCPF(documento) || validators.validarCNPJ(documento);
            },
    
            remoteMethod(query) {
                setTimeout(() => {
                    this.buscarPessoas(query);
                }, 800);
            },
    
            getFiltros(query) {
                const filtro = {};
                filtro.page = this.paginacao.paginaAtual - 1;
                filtro.size = this.paginacao.tamanhoPagina;
                filtro.searchText = query || '';
                if (this.isDocumentoBusca(query)) {
                    filtro.searchText = formatters.documentoFormatToNumeral(query);
                }
                filtro.order = '&sort=nome_razao_social,asc';
                return filtro;
            },
    
            async buscarPessoas(query) {
                try {
                    const { data } = await RepresentanteService.findAllByFiltro(
                        this.getFiltros(query)
                    );
                    this.listaPessoas = data.resultados;
                } catch (error) {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.falhaCarregamentoDadosPessoas')
                    });
                }
            },
    
            async buscarPapeis() {
                try {
                    const { data } = await PapelPessoaService.buscarPapelPorLocalidade('es');
                    this.listaPapeis = data;
                } catch (error) {
                    this.$notify.error({
                        message: error.message
                    });
                }
            },

            async editarPessoa(representante) {
                await this.buscarPessoas();

                if (!this.idPessoaSelecionada || !this.idPapelSelecionado) {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.selecaoPessoaPapel')
                    });
                    return;
                }
    
                const checagem = this.pessoasOperacoes.find(
                    p =>
                        p.pessoa.id === this.idPessoaSelecionada &&
                        p.papel.id === this.idPapelSelecionado
                );
    
                if (checagem) {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.pessoaPapelJaSelecionada')
                    });
                    return;
                }

                const pessoaSelecionada = this.listaPessoas.find(
                    p => p.id === representante.id
                );
    
                if (pessoaSelecionada.email === null) {
                    pessoaSelecionada.email = '-';
                }
    
                if (pessoaSelecionada.idCliente === null) {
                    pessoaSelecionada.idCliente = '-';
                }
    
                const papelSelecionado = this.listaPapeis.find(
                    p => p.id === this.idPapelSelecionado
                );
    
                this.pessoasOperacoes.push({
                    pessoa: pessoaSelecionada,
                    papel: papelSelecionado
                });
    
                this.idPessoaSelecionada = null;
                this.idPapelSelecionado = null;
                this.listaPessoas = [];
                this.buscarPessoas();
    
                this.atualizarListaPessoas();
            },
    
            async addPessoa() {
                if (!this.idPessoaSelecionada || !this.idPapelSelecionado) {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.selecaoPessoaPapel')
                    });
                    return;
                }
    
                const checagem = this.pessoasOperacoes.find(
                    p =>
                        p.pessoa.id === this.idPessoaSelecionada &&
                        p.papel.id === this.idPapelSelecionado
                );
    
                if (checagem) {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.pessoaPapelJaSelecionada')
                    });
                    return;
                }
    
                const pessoaSelecionada = this.listaPessoas.find(
                    p => p.id === this.idPessoaSelecionada
                );
    
                if (pessoaSelecionada.email === null) {
                    pessoaSelecionada.email = '-';
                }
    
                if (pessoaSelecionada.idCliente === null) {
                    pessoaSelecionada.idCliente = '-';
                }
    
                const papelSelecionado = this.listaPapeis.find(
                    p => p.id === this.idPapelSelecionado
                );
    
                this.pessoasOperacoes.push({
                    pessoa: pessoaSelecionada,
                    papel: papelSelecionado
                });
    
                this.idPessoaSelecionada = null;
                this.idPapelSelecionado = null;
                this.listaPessoas = [];
                this.buscarPessoas();
    
                this.atualizarListaPessoas();
            },
    
            openModalRemover(pessoaOperacao) {
                this.pessoaOperacaoSelecionada = pessoaOperacao;
                this.deletePessoaModal = true;
            },
    
            closeModalRemover() {
                this.deletePessoaModal = false;
            },
    
            deletePessoa() {
                if (this.pessoaOperacaoSelecionada) {
                    this.pessoasOperacoes.splice(
                        this.pessoasOperacoes.indexOf(
                            this.pessoaOperacaoSelecionada
                        ),
                        1
                    );
                    this.deletePessoaModal = false;
                    this.atualizarListaPessoas();
                }
            },
    
            cadastrarPessoa() {
                this.editar = false;
                this.mostrarModalEditarCadastrarRepresentante = true;
            },
    
            fecharModalEditarCadastrarRepresentante() {
                this.dadosRepresentanteCadastro = {};
                this.mostrarModalEditarCadastrarRepresentante = false;
            },
    
            atualizarListaPessoas() {
                const pessoas = [];
                this.pessoasOperacoes.forEach(pp => {
                    pessoas.push({
                        ...pp.pessoa,
                        idPapel: pp.papel.id,
                        territorioPapelPessoa: pp.papel
                    });
                });
                this.$emit('dadosPessoa', pessoas);
            },

            async verificarEdicao(newValue) {
                const newPessoaOperacao = newValue.map(f => ({
                        pessoa: {...f},
                        papel: f.territorioPapelPessoa
                    }));

                this.pessoasOperacoes = newPessoaOperacao;

            this.atualizarListaPessoas();
        }
                
        }
    };
    </script>
    
    <style lang="scss" scoped>
    #pessoa-operacao {
        .form {
            padding: 2px 2px 2px 0;
    
            .pessoa {
                display: flex;
                justify-content: space-between;
            }
        }
    
        .w-100 {
            width: 100%;
        }
    
        .w-66 {
            width: 66%;
            padding-right: 10px;
        }
    
        .w-33 {
            width: 33%;
        }
    
        .icon {
            font-size: 25px;
            cursor: pointer;
            padding-top: 36px;
            padding-left: 8px;
            color: var(--primary);
        }
    
        .icon-remover {
            font-size: 22px;
            cursor: pointer;
            padding-left: 18px;
            color: var(--icon-remove);
        }
    
        .icon-view {
            font-size: 20px;
            cursor: pointer;
            padding-left: 18px;
        }
    
        .tabela {
            width: 100%;
            padding-top: 15px;
            padding-bottom: 10px;
            padding-left: 15px;
        }
    
        .titulo {
            font-size: 14px;
            color: var(--dimgray);
        }
    
        .sem-registro {
            font-size: 14px;
            color: var(--secondary-font-color);
        }
    
        .tituloColuna {
            font-size: 15px;
            color: var(--primary);
        }
    
        .margin {
            margin-bottom: 12px;
        }
    
        #modal-delete-pessoa {
            text-align: center;
        }
    
        .pessoa__btn-cadastro {
            border-radius: 20px !important;
        }
    
        .mb16 {
            margin-bottom: 16px;
        }
    
        .custon-icon {
            font-size: 16px;
        }
    
        .campo_obrigatorio {
            font-size: 14px;
            color: var(--primary);
            font-weight: normal !important;
        }

        .custom-hr {
            margin-bottom: 0.5rem;
            border-top: 2px solid rgba(0, 0, 0, 0.1);
        }

        .botao-adicionar {
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .icon-plus-vincular-pessoa {
            cursor: pointer;
            margin: 8px 0 0 6px;
            font-size: 15px;
            color: var(--white);
            width: 30px;
            height: 29px;
            background-color: var(--green);
            padding: 7px;
            border-radius: 2px;
        }

        .grid-info-pessoas {
            padding: 0;
            display: grid;
        }

        .sem-vinculo-box {
            padding-bottom: 10px;
            text-align: center
        }

        .remover-pessoa-title {
            text-align: left;
            font-size: 18px
        }
    }

    .custom-padding-pessoa-desejada {
        padding: 10px 5px 0px 20px;
    }

    .custom-padding-cadastrar-pessoa {
        padding: 5px 5px 5px 20px;
    }
</style>
